import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { BookButton } from './BookButton';
import { navLinks } from '../data/homepage';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 bg-navy transition-[box-shadow,background-color] duration-200 ease-out ${scrolled ? 'bg-navy/95 shadow-[0_1px_0_rgba(201,162,39,0.35)] backdrop-blur' : ''}`} data-id="element-114" data-mp="2gdohjaazqppa">
      <div className={`mx-auto flex max-w-7xl items-center justify-between px-6 transition-[height] duration-200 ease-out md:px-10 ${scrolled ? 'h-16' : 'h-20 md:h-24'}`} data-id="element-115" data-mp="2eidkcrjbzyd7">
        <a href="/" aria-label="Veterans For Life home" className="shrink-0" data-id="element-116" data-mp="2ohcnjulbv1st">
          <Logo compact={scrolled} data-id="element-117" data-mp="1qtko0tysroi2" />
        </a>

        <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-118" data-mp="1quvs6uw5my9p">
          <ul className="flex items-center gap-8" data-id="element-119" data-mp="1vtgpomk0v3ug">
            {navLinks.map(link => <li key={link.label} data-id="element-120" data-mp="20r8lhrnsfa3x">
                <a href={link.href} className="whitespace-nowrap text-base font-medium text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-121" data-mp="20q77bebh67hz">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <BookButton size="md" data-id="element-122" data-mp="1cztazbluxmhl" />
        </nav>

        <div className="flex items-center gap-4 lg:hidden" data-id="element-123" data-mp="150g991zk1c9f">
          <BookButton size="md" className="hidden md:inline-flex" data-id="element-124" data-mp="14yvgnhwsw3e7" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-11 w-11 items-center justify-center rounded-sm text-paper" data-id="element-125" data-mp="101lrm3dbptqw">
            {open ? <XIcon className="h-7 w-7" data-id="element-126" data-mp="h3anrr53ehf9" /> : <MenuIcon className="h-7 w-7" data-id="element-127" data-mp="h42eanju1oyo" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-128" data-mp="w1324fywkzrv">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-gold/30 bg-navy px-6 pb-8 pt-4 lg:hidden" data-id="element-129" data-mp="w1uxpqsi2xi5">
            <ul className="flex flex-col" data-id="element-130" data-mp="29zd72dsivemz">
              {navLinks.map(link => <li key={link.label} className="border-b border-paper/10" data-id="element-131" data-mp="2ezhnk3tfk9d7">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-4 text-xl font-medium text-paper" data-id="element-132" data-mp="20zq5nrzsm8tx">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <BookButton fullWidth className="mt-6" data-id="element-133" data-mp="2xq8smt6dxdls" />
          </motion.nav>}
      </AnimatePresence>
    </header>;
}